import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HERO_VIAL = "https://customer-assets.emergentagent.com/job_peptide-marketplace-8/artifacts/qznr7ssu_Tirzepatide%20PDC-1-%20White.png";

const fade = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.9, delay: 0.15 + i * 0.12, ease: [0.16, 1, 0.3, 1] } }),
};

export default function Hero() {
  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden hero-fog">
      <div className="relative z-10 mx-auto max-w-[1500px] w-full px-6 sm:px-10 pt-28 pb-20 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <motion.p variants={fade} initial="hidden" animate="show" custom={0} className="text-[11px] uppercase tracking-[0.3em] text-[#4ADE80] mb-8">
            EndaG1 Research · Est. Precision
          </motion.p>
          <motion.h1
            variants={fade} initial="hidden" animate="show" custom={1}
            className="font-display font-semibold text-[#F5F5F5] tracking-[-0.03em] leading-[0.92] text-5xl md:text-7xl lg:text-8xl"
          >
            Precision is<br />Everything.
          </motion.h1>
          <motion.p variants={fade} initial="hidden" animate="show" custom={2} className="mt-9 max-w-xl text-lg md:text-xl text-[#A8A8A8] font-light leading-relaxed">
            Research peptides manufactured to exacting standards, independently verified, and trusted by laboratories committed to scientific excellence.
          </motion.p>
          <motion.div variants={fade} initial="hidden" animate="show" custom={3} className="mt-11 flex flex-col sm:flex-row gap-4">
            <Link to="/products" data-testid="hero-cta-primary" className="btn-press inline-flex items-center justify-center gap-2 bg-[#4ADE80] text-[#0F0F10] uppercase tracking-[0.18em] text-[12px] px-9 py-4 hover:bg-[#6FE998]">
              Explore Collection <ArrowRight className="h-4 w-4" />
            </Link>
            <a href="#process" data-testid="hero-cta-secondary" className="btn-press inline-flex items-center justify-center gap-2 border border-white/20 text-[#F5F5F5] uppercase tracking-[0.18em] text-[12px] px-9 py-4 hover:border-[#4ADE80] hover:text-[#4ADE80]">
              View Certificates
            </a>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.94 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1.3, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-5 relative flex justify-center"
        >
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="h-[80%] w-[80%] rounded-full bg-[#4ADE80]/12 blur-[110px]" />
          </div>
          <motion.img
            src={HERO_VIAL}
            alt="EndaG1 research peptide vial, studio lit"
            animate={{ y: [0, -16, 0] }}
            transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
            className="relative z-10 max-h-[68vh] w-auto object-contain vial-blend-soft drop-shadow-[0_40px_80px_rgba(0,0,0,0.6)]"
          />
          <div className="absolute bottom-[8%] left-1/2 -translate-x-1/2 h-4 w-40 bg-black/60 blur-2xl rounded-[100%]" />
        </motion.div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-[#7a7a7a]">
        <span className="text-[10px] uppercase tracking-[0.3em]">Scroll</span>
        <div className="h-10 w-px bg-gradient-to-b from-[#4ADE80] to-transparent" />
      </div>
    </section>
  );
}
